<div class="flex flex-col py-2" style="background-color: #022b3a; padding: 0 20px;">
  <div class="heading flex flex-row justify-between">
    <h2 class="text-white text-lg">Bulk Export</h2>
  </div>
</div>

<div class="bulk-export-container bg-white py-2 px-2 rounded mx-16 my-8 user-settings-container">
  <div *ngIf="columnView.open" class="dimming-overlay"></div>

  <div class="user-settings-content">
    <form *ngIf="downloadDataForm" [formGroup]="downloadDataForm" autocomplete="off">
      <div class="flex justify-between items-center">
        <div class="flex justify-between items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
            <path
              d="M14.8235 6.35294H10.5882V0H4.23529V6.35294H0L7.41176 13.7647L14.8235 6.35294ZM0 15.8824V18H14.8235V15.8824H0Z"
              fill="#1F7A8C"
            />
          </svg>
          <h2 class="text-lg font-semibold ml-1">Bulk Export</h2>
        </div>
        <button
          *ngIf="columns.value"
          class="flex justify-between items-center py-1 px-2 rounded"
          style="background-color: #1F7A8C;"
          (click)="openColumnView({})"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none">
            <path
              d="M0.0249023 12V2C0.0249023 1.45 0.220736 0.979167 0.612402 0.5875C1.00407 0.195833 1.4749 0 2.0249 0H15.9999C16.5499 0 17.0207 0.195833 17.4124 0.5875C17.8041 0.979167 17.9999 1.45 17.9999 2V12C17.9999 12.55 17.8041 13.0208 17.4124 13.4125C17.0207 13.8042 16.5499 14 15.9999 14H2.0249C1.4749 14 1.00407 13.8042 0.612402 13.4125C0.220736 13.0208 0.0249023 12.55 0.0249023 12ZM1.9999 12H5.3249V2H1.9999V12ZM7.3249 12H10.6499V2H7.3249V12ZM12.6499 12H15.9749V2H12.6499V12Z"
              fill="#EDF6F9"
            />
          </svg>
          <span class="text-white ml-1">COLUMNS</span>
        </button>
      </div>

      <div class="flex flex-row gap-1 items-center">
        <div class="flex flex-col" style="flex-grow: 1;">
          <div>Start Date</div>
          <mat-form-field appearance="outline">
            <input
              matInput
              class="datepicker-input "
              placeholder="Choose start date"
              autocomplete="off"
              [formControl]="downloadDataForm.controls['startDate']"
              [owlDateTime]="dt1"
              [owlDateTimeTrigger]="dt1"
              saAutomatedSelector="bulk-export__start-Date"
            />
            <span [owlDateTimeTrigger]="dt1"><i class="material-icons">calendar_today</i></span>
            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
            <mat-error *ngIf="downloadDataForm.controls['startDate'].hasError('required')">
              Input is required
            </mat-error>
          </mat-form-field>
        </div>

        <div style="flex-grow: 0;">
          <i class="material-icons" style="color: #1F7A8C;">arrow_forward</i>
        </div>

        <div class="flex flex-col" style="flex-grow: 1;">
          <div>End Date</div>
          <mat-form-field appearance="outline">
            <input
              matInput
              class="datepicker-input "
              placeholder="Choose end date"
              autocomplete="off"
              [min]="downloadDataForm.get('startDate').value || todayDate"
              [max]="todayDate"
              [formControl]="downloadDataForm.controls['endDate']"
              [owlDateTime]="dt2"
              [owlDateTimeTrigger]="dt2"
              saAutomatedSelector="bulk-export__end-Date"
            />
            <span [owlDateTimeTrigger]="dt2"><i class="material-icons">calendar_today</i></span>
            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
            <mat-error *ngIf="downloadDataForm.controls['endDate'].hasError('required')">
              Input is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-row gap-1 items-center">
        <div class="flex flex-col" style="flex-grow: 1;">
          <div>Trucking Company</div>
          <mat-form-field appearance="outline">
            <mat-select
              formControlName="vendors"
              saAutomatedSelector="truck-contract__trucking-company"
              placeholder="Trucking Companies"
              multiple
            >
              <mat-option>
                <ngx-mat-select-search
                  [placeholderLabel]="'Trucking Company'"
                  [noEntriesFoundLabel]="'No matching trucking company found'"
                  [formControl]="vendorFilter"
                >
                </ngx-mat-select-search>
              </mat-option>

              <mat-option *ngFor="let vendor of allVendors$ | async" [value]="vendor">
                {{ vendor.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-row gap-1 items-center">
        <div class="flex flex-col" style="flex-grow: 1;">
          <div>Well</div>
          <mat-form-field appearance="outline">
            <mat-select formControlName="fracs" placeholder="Well" multiple>
              <mat-option>
                <ngx-mat-select-search
                  [placeholderLabel]="'Well'"
                  [noEntriesFoundLabel]="'No matching well found'"
                  [formControl]="fracFilter"
                >
                </ngx-mat-select-search>
              </mat-option>

              <mat-option *ngFor="let frac of allFracs$ | async" [value]="frac">
                {{ frac.site.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-row gap-1 items-center">
        <div>Export By:</div>
        <mat-radio-group class="mr-2" [formControl]="downloadDataForm.controls['exportBy']">
          <mat-radio-button class="mr-2" [value]="ExportBy.DispatchTimestamp">Dispatch Timestamp</mat-radio-button>
          <mat-radio-button class="mr-2" [value]="ExportBy.ApprovalTimestamp">Approval Timestamp</mat-radio-button>
          <mat-radio-button [value]="ExportBy.CompletedAtTimestamp">Completed At Timestamp</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="flex flex-row gap-1 items-center mt-1">
        <mat-checkbox *saFeatureFlag="'bulkExportEmailCheckbox'" [formControl]="downloadDataForm.controls['email']"
          >Send via E-mail to <span class="italic">{{ userEmail.value }}</span></mat-checkbox
        >
      </div>

      <div class="flex flex-row gap-1 items-center mt-4">
        <button
          [disabled]="!columns.value"
          class="flex justify-between items-center py-1 px-2 rounded"
          style="background-color: #1F7A8C;"
          type="submit"
          (click)="fetchPreviewData(null)"
        >
          <svg
            *ngIf="!isFetchingPreview"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
          >
            <path
              d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V4H2V16ZM9 14C7.63333 14 6.4125 13.6292 5.3375 12.8875C4.2625 12.1458 3.48333 11.1833 3 10C3.48333 8.81667 4.2625 7.85417 5.3375 7.1125C6.4125 6.37083 7.63333 6 9 6C10.3667 6 11.5875 6.37083 12.6625 7.1125C13.7375 7.85417 14.5167 8.81667 15 10C14.5167 11.1833 13.7375 12.1458 12.6625 12.8875C11.5875 13.6292 10.3667 14 9 14ZM9 12.5C9.93333 12.5 10.7833 12.2792 11.55 11.8375C12.3167 11.3958 12.9167 10.7833 13.35 10C12.9167 9.21667 12.3167 8.60417 11.55 8.1625C10.7833 7.72083 9.93333 7.5 9 7.5C8.06667 7.5 7.21667 7.72083 6.45 8.1625C5.68333 8.60417 5.08333 9.21667 4.65 10C5.08333 10.7833 5.68333 11.3958 6.45 11.8375C7.21667 12.2792 8.06667 12.5 9 12.5ZM9 11.5C9.41667 11.5 9.77083 11.3542 10.0625 11.0625C10.3542 10.7708 10.5 10.4167 10.5 10C10.5 9.58333 10.3542 9.22917 10.0625 8.9375C9.77083 8.64583 9.41667 8.5 9 8.5C8.58333 8.5 8.22917 8.64583 7.9375 8.9375C7.64583 9.22917 7.5 9.58333 7.5 10C7.5 10.4167 7.64583 10.7708 7.9375 11.0625C8.22917 11.3542 8.58333 11.5 9 11.5Z"
              fill="#EDF6F9"
            />
          </svg>
          <svg
            *ngIf="isFetchingPreview"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 200 200"
          >
            <radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
              <stop offset="0" stop-color="#FFFFFF"></stop>
              <stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop>
              <stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop>
              <stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop>
              <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop>
            </radialGradient>
            <circle
              transform-origin="center"
              fill="none"
              stroke="url(#a12)"
              stroke-width="15"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
              stroke-dashoffset="0"
              cx="100"
              cy="100"
              r="70"
            >
              <animateTransform
                type="rotate"
                attributeName="transform"
                calcMode="spline"
                dur="2"
                values="360;0"
                keyTimes="0;1"
                keySplines="0 0 1 1"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
            <circle
              transform-origin="center"
              fill="none"
              opacity=".2"
              stroke="#FFFFFF"
              stroke-width="15"
              stroke-linecap="round"
              cx="100"
              cy="100"
              r="70"
            ></circle>
          </svg>
          <span class="text-white ml-1">PREVIEW</span>
        </button>
        <button
          class="flex justify-between items-center py-1 px-2 rounded"
          style="background-color: #1F7A8C;"
          type="submit"
          [disabled]="isDownloading"
          (click)="downloadData()"
        >
          <svg
            *ngIf="!isDownloading"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V11H2V14H14V11H16V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2Z"
              fill="#EDF6F9"
            />
          </svg>
          <svg *ngIf="isDownloading" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 200 200">
            <radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
              <stop offset="0" stop-color="#FFFFFF"></stop>
              <stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop>
              <stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop>
              <stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop>
              <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop>
            </radialGradient>
            <circle
              transform-origin="center"
              fill="none"
              stroke="url(#a12)"
              stroke-width="15"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
              stroke-dashoffset="0"
              cx="100"
              cy="100"
              r="70"
            >
              <animateTransform
                type="rotate"
                attributeName="transform"
                calcMode="spline"
                dur="2"
                values="360;0"
                keyTimes="0;1"
                keySplines="0 0 1 1"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
            <circle
              transform-origin="center"
              fill="none"
              opacity=".2"
              stroke="#FFFFFF"
              stroke-width="15"
              stroke-linecap="round"
              cx="100"
              cy="100"
              r="70"
            ></circle>
          </svg>
          <span class="text-white ml-1 font">{{ isDownloading ? 'DOWNLOADING' : 'DOWNLOAD' }}</span>
        </button>
        <button
          *ngIf="showUpdateTemplateButton.value"
          class="flex justify-between items-center py-1 px-2 rounded"
          style="background-color: #1F7A8C;"
          type="submit"
          [disabled]="isUpdating"
          (click)="updateTemplateArrangement()"
        >
          <svg
            *ngIf="!isUpdating"
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#FFFFFF"
          >
            <path
              d="M280-120 80-320l200-200 57 56-104 104h607v80H233l104 104-57 56Zm400-320-57-56 104-104H120v-80h607L623-784l57-56 200 200-200 200Z"
            />
          </svg>
          <svg *ngIf="isUpdating" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 200 200">
            <radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
              <stop offset="0" stop-color="#FFFFFF"></stop>
              <stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop>
              <stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop>
              <stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop>
              <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop>
            </radialGradient>
            <circle
              transform-origin="center"
              fill="none"
              stroke="url(#a12)"
              stroke-width="15"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
              stroke-dashoffset="0"
              cx="100"
              cy="100"
              r="70"
            >
              <animateTransform
                type="rotate"
                attributeName="transform"
                calcMode="spline"
                dur="2"
                values="360;0"
                keyTimes="0;1"
                keySplines="0 0 1 1"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
            <circle
              transform-origin="center"
              fill="none"
              opacity=".2"
              stroke="#FFFFFF"
              stroke-width="15"
              stroke-linecap="round"
              cx="100"
              cy="100"
              r="70"
            ></circle>
          </svg>
          <span class="text-white ml-1 font">{{ isUpdating ? 'UPDATING' : 'UPDATE TEMPLATE' }}</span>
        </button>
      </div>
    </form>

    <div *ngIf="!tableData.value" class="flex items-center mt-8">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
          d="M0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16ZM2 6H16V2H2V6ZM7.325 11H10.675V8H7.325V11ZM7.325 16H10.675V13H7.325V16ZM2 11H5.325V8H2V11ZM12.675 11H16V8H12.675V11ZM2 16H5.325V13H2V16ZM12.675 16H16V13H12.675V16Z"
          fill="#1F7A8C"
        />
      </svg>
      <p class="ml-1">Click on the Preview button to examine your data and columns before exporting</p>
    </div>

    <div class="flex flex-col justify-between mt-8">
      <div *ngIf="isApplying" class="justify-start items-start flex flex-row mb-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 200 200">
          <radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
            <stop offset="0" stop-color="#1F7A8C"></stop>
            <stop offset=".3" stop-color="#1F7A8C" stop-opacity=".9"></stop>
            <stop offset=".6" stop-color="#1F7A8C" stop-opacity=".6"></stop>
            <stop offset=".8" stop-color="#1F7A8C" stop-opacity=".3"></stop>
            <stop offset="1" stop-color="#1F7A8C" stop-opacity="0"></stop>
          </radialGradient>
          <circle
            transform-origin="center"
            fill="none"
            stroke="url(#a12)"
            stroke-width="15"
            stroke-linecap="round"
            stroke-dasharray="200 1000"
            stroke-dashoffset="0"
            cx="100"
            cy="100"
            r="70"
          >
            <animateTransform
              type="rotate"
              attributeName="transform"
              calcMode="spline"
              dur="2"
              values="360;0"
              keyTimes="0;1"
              keySplines="0 0 1 1"
              repeatCount="indefinite"
            ></animateTransform>
          </circle>
          <circle
            transform-origin="center"
            fill="none"
            opacity=".2"
            stroke="#FFFFFF"
            stroke-width="15"
            stroke-linecap="round"
            cx="100"
            cy="100"
            r="70"
          ></circle>
        </svg>
        <p></p>
        Applying new data...
      </div>
      <div class="relative">
        <div *ngIf="!tableData.value" class="hot-table-overlay"></div>
        <div class="custom-hot-table" #previewTableContainer></div>
      </div>
    </div>
  </div>

  <div class="detail-view-container mirror" [@slideInOut] *ngIf="columnView.open">
    <sa-bulk-export-columns
      *ngIf="columnView.open"
      (onColumnsUpdated)="updateTableHeaderColumn($event)"
      (onSaveTempColumns)="saveTempColumn($event)"
      (onSaveTempSelectedTemplate)="saveTempSelectedTemplate($event)"
      (onAddNewTemplate)="addNewTemplate($event)"
      (onUpdateTemplate)="updateTemplate($event)"
      (onDeleteTemplate)="deleteTemplate($event)"
      (onClose)="closeClicked()"
      (onShowUpdateTemplateButton)="setShowUpdateTemplateButton($event)"
      [addedTemplate]="newlyAddedTemplateId.value"
      [columns]="columnView.columns"
      [fetchExportColumnTemplate]="fetchExportColumnTemplate.value"
      [tempSelectedTemplate]="tempSelectedTemplate.value"
    ></sa-bulk-export-columns>
  </div>
</div>
